module.exports = __webpack_public_path__ + "img/BAS_BambooHR.152dc1ec.svg";